export default ({request}) => ({
  changeOrderInspectionListApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspection/list',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspection/detail',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspection/save',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspection/batchDel',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionBatchListApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionBatch/list',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionBatchSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionBatch/save',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionBatchsDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionBatch/del',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocListApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDoc/list',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDoc/detail',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDoc/batch/upload',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDoc/del',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocUpdateApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDoc/update',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocBatchListApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDocBatch/list',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocBatchSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDocBatch/save',
      method: 'post',
      data,
    })
  },
  changeOrderInspectionDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderInspectionDocBatch/del',
      method: 'post',
      data,
    })
  },
})
